module.exports = __webpack_public_path__ + "static/the-rational-optimist-ead532e6a64ade97e3a257746361fc7a.jpg";